"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;
exports.settings = {
  debug: false,
  gravity: 800,
  zIndex: 99999,
  respectReducedMotion: true
};